module.exports = __webpack_public_path__ + "assets/img/20220121.52f5a93c.png";